import React, { Fragment, useState, useContext, useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import {
  Grid,
  DialogActions,
  DialogContent,
  Alert,
  Dialog,
  Box,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import {
  AddCircleOutlineOutlined,
  CloudSyncOutlined,
} from "@mui/icons-material";

import {
  cardBodyStyle,
  ButtonExit,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function NewCardLink(props) {
  const classes = useStyles();

  const [error, setError] = useState(false);
  const [loader, setLoader] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [alert, setAlert] = useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });

  const { urlServices, LightboxPlaceToPay } = useContext(UrlServicesContext);

  const dataClient = props.row;

  // Cargar el script del Lightbox en el componente
  useEffect(() => {
    const script = document.createElement("script");
    script.src = LightboxPlaceToPay;
    script.async = true;
    document.body.appendChild(script);

    // Limpiar el script al desmontar el componente
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const sendData = () => () => {
    setDisabledButton(true);
    setAlert({ ...alert, openAlert: false });

    const dataValue = {
      document: dataClient.client.documentId,
      documentType: dataClient.client.typeDocument,
      name: `${dataClient.client.name1} ${dataClient.client.name2}`,
      surname: `${dataClient.client.lastName1} ${dataClient.client.lastName2}`,
      email: dataClient.client.email,
      mobile: `+${dataClient.client.prefix?.prefix}${dataClient.client.phone}`,
      clientsId: dataClient.client.id,
      slug: dataClient.slug,
    };

    axios
      .post(`${urlServices}placetopay/create-card-collection`, dataValue)
      .then((response) => {
        openLightbox(response.data);
        // window.open(response.data.data.processUrl, "_blank");
      })
      .catch((error) => {
        handleError(error);
      });
  };

  // Función para abrir el Lightbox
  const openLightbox = (valuesData) => {
    if (window.P) {
      let callbackExecuted = false;

      const responseCallback = function (response) {
        if (!callbackExecuted) {
          callbackExecuted = true;
          submitRequestPay(valuesData.cardCollectionClient);
        }
      };

      window.P.on("response", responseCallback);

      window.P.init(valuesData.data.processUrl, { backupTarget: "popup" });
    }
  };

  const submitRequestPay = async (cardCollectionClient) => {
    try {
      setLoader(true);

      const response = await axios.post(
        `${urlServices}placetopay/view-pay-card-collection/${cardCollectionClient.requestIdTransaction}`
      );
      if (response.status === 201) {
        const status = response.data.data.status;
        if (status.status === "REJECTED") {
          setAlert({
            openAlert: true,
            errorAlert: "error",
            mensaje: status.message,
            /*" (Estado: RECHAZADA y Referencia: " +
                    cardCollectionClient.reference +
                    ")"*/
          });
        } else if (status.status === "APPROVED") {
          setAlert({
            openAlert: true,
            errorAlert: "success",
            mensaje: "Su tarjeta fué registrada exitosamente.",
            /* (Estado: APROBADA y Referencia: " +
                    cardCollectionClient.reference +
                    ")"*/
          });
        }
        submitSave(
          cardCollectionClient.clientsId,
          cardCollectionClient.id,
          response.data.data
        );
      }
    } catch (error) {
      handleError(error);
    }
  };

  const submitSave = async (clientsId, id, data) => {
    const dataValue = {
      clientsIdSelect: clientsId,
      responseTransaction: JSON.stringify(data),
      status: data.status.status === "APPROVED" ? 1 : 0,
      select: 0,
    };

    /* if (data.status.status === "APPROVED") {
      dataValue.selectCard = true;
    }*/

    try {
      const response = await axios.put(
        `${urlServices}card-collection-client/${id}`,
        dataValue
      );
      if (response.status === 200) {
        setLoader(false);
        if (data.status.status === "APPROVED") {
          props.callBack();
        }
      }
    } catch (error) {
      handleError(error); // Usa el mismo manejador de errores aquí
    }
  };

  // Manejo común de errores
  const handleError = (error) => {
    if (error.response?.status === 404) {
      setMensageSystem("Registro no encontrado.");
      setError(true);
    } else if (error.response?.status === 500) {
      setMensageSystem("Error en la consulta con el servidor.");
      setError(true);
    } else {
      console.error("Error en la solicitud:", error);
      setMensageSystem("Error al realizar la solicitud.");
      setError(true);
    }
    setLoader(false);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  return (
    <Fragment>
      <Dialog
        fullWidth
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                {error && <Alert severity="error">{mensageSystem}</Alert>}
              </Grid>
              <Grid item xs={12} sm={12}>
                {alert.openAlert ? (
                  <Alert
                    severity={
                      alert.errorAlert === "success" ? "success" : "error"
                    }
                    icon={false}
                    sx={{ fontSize: 14 }}
                  >
                    {alert.mensaje}
                  </Alert>
                ) : (
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{
                        background: "#F6F6F6",
                        py: 6,
                        textAlign: "center",
                        "&:hover": {
                          background: "#F1F1F1",
                        },
                      }}
                      className={classes.containerProfile}
                    >
                      {!disabledButton ? (
                        <Box
                          component="a"
                          sx={{ textDecoration: "none", cursor: "pointer" }}
                          onClick={sendData()}
                        >
                          <AddCircleOutlineOutlined
                            sx={{ fontSize: 52, color: "green" }}
                          />
                          <div
                            className={classes.titleCardFilter}
                            style={{ fontSize: 14, fontWeight: "bold" }}
                          >
                            Agregar nueva tarjeta
                          </div>
                        </Box>
                      ) : (
                        <>
                          <CloudSyncOutlined
                            sx={{ fontSize: 52, color: "#000" }}
                          />{" "}
                          <div
                            className={classes.titleCardFilter}
                            style={{ fontSize: 14, fontWeight: "bold" }}
                          >
                            Transacción en proceso...
                          </div>
                        </>
                      )}
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Fragment>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
      <Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
}
